export const getters = {
  getBandeiraCartao: (state) => state.bandeiraCartao,
  getBandeirasCartao: (state) => state.bandeirasCartao,
  getModalCadastroBandeiraCartao: (state) => state.modalCadastrarBandeiraCartao,
  getModalExcluirBandeiraCartao: (state) => state.modalExcluirBandeiraCartao,
  getModalPesquisarBandeiraCartao: (state) => state.modalPesquisarBandeiraCartao,
};

export default {};
